import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import { Fetch, Login } from '@store/session/service';
import { name, Adapter, UploadAvatar, } from '@store/user/service';
import { createSlice, } from '@reduxjs/toolkit';
var Slice = createSlice({
    name: name,
    initialState: Adapter.getInitialState({}),
    reducers: {
        updateAvatar: function (state, action) {
            if (action.payload.userId === void 0) {
                return state;
            }
            Adapter.updateOne(state, {
                id: action.payload.userId,
                changes: { avatar: action.payload.url },
            });
        },
    },
    extraReducers: function (builder) {
        builder
            .addCase(UploadAvatar.pending, function (state, action) {
            console.log("" + action.type);
        })
            .addCase(UploadAvatar.fulfilled, function (state, action) {
            console.log("" + action.type);
        })
            .addCase(UploadAvatar.rejected, function (state, action) {
            console.log("" + action.type);
        })
            .addMatcher(function (action) {
            /** 登录成功或者获取当前登录用户成功时，触发 */
            return (action.type === Login.fulfilled.type ||
                action.type === Fetch.fulfilled.type);
        }, function (state, action) {
            Adapter.upsertOne(state, action);
        });
    },
});
var selectors = Adapter.getSelectors();
var stateSelector = createSelector(function (state) { return state; }, function (state) { return state.user; });
var userSelector = createSelector(function (state) { return state; }, function (_state, userId) { return userId; }, function (state, userId) {
    if (userId === void 0 || userId === null) {
        return void 0;
    }
    return selectors.selectById(state, userId);
});
var unitsSelector = createSelector(userSelector, function (user) {
    return user === void 0 ? [] : user.unitList;
});
var organizationsSelector = createSelector(userSelector, function (user) {
    return user === void 0 ? [] : user.organList;
});
var modulesSelector = createSelector(userSelector, function (user) {
    return user === void 0
        ? []
        : user === null || user === void 0 ? void 0 : user.extraMap.modules.filter(function (item) { return item.active !== 2; });
});
var filterModulesSelector = createSelector(modulesSelector, function (_state, _userId, type) { return type; }, function (modules, type) {
    return modules.filter(function (item) {
        /** 菜单系统模块 */
        var isMenu = item.code === 'organ-management' || item.code === 'school-management';
        /** 首页图表右则较大模块 */
        var isLarger = item.code !== 'organ-management' && item.code !== 'school-management';
        /**
         * type === 0 时，返回菜单系统模块
         * type === 1 时，返回首页图表右则较大模块
         * type === 2 时，返回首页图表下方较小模块
         * */
        return type === 0 ? isMenu : isLarger;
    });
});
var userTypeSelector = createSelector(userSelector, function (user) {
    return user === null || user === void 0 ? void 0 : user.extraMap.userLoginType;
});
var optionsSelector = createSelector(userSelector, userTypeSelector, function (user, userType) {
    if (user === void 0 || user === null) {
        return [];
    }
    var options = [];
    /** 2: 机构， 3：学校 */
    if (userType === 2) {
        var orgs = user.organList.map(function (item) {
            return { label: item.organName, value: item.organID, type: 2 };
        });
        options.push.apply(options, orgs);
    }
    /** 返回学校列表 */
    var unitSet = user.unitList.reduce(function (sets, item) {
        return (sets[item.parentUnitID] = item), sets;
    }, {});
    var units = Object.keys(unitSet).map(function (id) {
        var unit = unitSet[id];
        return Object.assign({}, unit, {
            label: unit.parentUnitName,
            value: unit.parentUnitID,
            type: 3,
        });
    });
    return options.concat(units);
});
export var useUserState = function () {
    return useSelector(stateSelector);
};
export var useUser = function (userId) {
    return userSelector(useUserState(), userId);
};
export var useUserType = function (userId) {
    var _a;
    return ((_a = useUser(userId)) === null || _a === void 0 ? void 0 : _a.extraMap.userLoginType) || 2;
};
export var useModules = function (userId, type) {
    var state = useUserState();
    if (type === void 0 || type === null) {
        return modulesSelector(state, userId);
    }
    return filterModulesSelector(state, userId, type);
};
export var useUnits = function (userId) {
    return unitsSelector(useUserState(), userId);
};
export var useOrganizations = function (userId) {
    return organizationsSelector(useUserState(), userId);
};
export var useOptions = function (userId) {
    return optionsSelector(useUserState(), userId);
};
export var reducer = Slice.reducer, actions = Slice.actions;
